module.exports = __webpack_public_path__ + "img/ca8514f.webp";